<template>
  <div>
    <headbox title="卖出结算" bgColor="#fff" isborder="true"></headbox>
    <div v-if="startload">
      <center id="loadingbox">
        <van-loading size="50px" />
      </center>
    </div>
    <!-- <template >
          <van-empty
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />e
        </template> -->
    <div v-if="!startload">
      <!-- 卖出结算 -->
      <template v-if="ishow">
        <van-empty
          class="custom-image"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
        />
      </template>
      <template v-if="!ishow">
        <!-- 个人中心待确认跳转过来的，只显示待确认页面 -->
        <!-- <div v-if="isTobeconfirmed"> -->
        <div v-if="havedataboolean">
          <div v-for="(items, index) in selllist" :key="items.id" >
            <div class="time" v-if="newproductlist[index].ishavadata">
              {{ items.date }}
            </div>
            <div
              v-for="(itemslist, index) in items.orderList"
              :key="index"
              @click="hrefdetails(itemslist.orderId, itemslist.payStatus)"
            >
            <!-- itemslist.payStatus == 0 则显示 -->
              <div v-if="isTobeconfirmed == false || itemslist.payStatus == 2">
                <div class="flex-between detailsbox">
                  <div class="flex">
                    <div>
                      <div class="sellbox">卖</div>
                    </div>
                    <div class="product_msg ">
                      <div>
                        <div class="f30_black">
                          折算重量：{{ itemslist.weight }}g
                        </div>
                        <div class="f24_gray">{{ itemslist.date }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="flex onlyicon">
                    <div>
                      <div
                        class="f32"
                        :class="
                          itemslist.payStatus == '0'
                            ? 'PendPayment'
                            : itemslist.payStatus == '1'
                            ? ''
                            : 'toConfirmed'
                        "
                      >
                        {{ itemslist.money }}
                      </div>
                      <div
                        class=" f24 tr mart20"
                        :class="
                          itemslist.payStatus == '0'
                            ? 'PendPayment'
                            : itemslist.payStatus == '1'
                            ? 'overgetmoney'
                            : 'toConfirmed'
                        "
                      >
                        {{
                          itemslist.payStatus == "0"
                            ? "待付款"
                            : itemslist.payStatus == "1"
                            ? "已付款"
                            : "待确认"
                        }}
                      </div>
                    </div>
                    <div class="iconbox">
                      <div><i class="el-icon-arrow-right"></i></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 数据为空 -->
          </div>
        </div>
        <div v-else>
          <van-empty
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />
        </div>
        <!-- </div> -->

        <!-- <div v-if="!isTobeconfirmed">
          <div v-for="items in selllist" :key="items.id">
            <div class="time">{{ items.date }}</div>
            <div
              v-for="(itemslist, index) in items.orderList"
              :key="index"
              @click="hrefdetails(itemslist.orderId, itemslist.payStatus)"
            >
              <div class="flex-between detailsbox">
                <div class="flex">
                  <div>
                    <div class="sellbox">卖</div>
                  </div>
                  <div class="product_msg ">
                    <div>
                      <div class="f30_black">
                        来料总重：{{ itemslist.weight }}g
                      </div>
                      <div class="f24_gray">{{ itemslist.date }}</div>
                    </div>
                  </div>
                </div>
                <div class="flex onlyicon">
                  <div>
                    <div
                      class="f32"
                      :class="
                        itemslist.payStatus == '0'
                          ? 'PendPayment'
                          : itemslist.payStatus == '1'
                          ? ''
                          : 'toConfirmed'
                      "
                    >
                      {{ itemslist.money }}
                    </div>
                    <div
                      class=" f24 tr mart20"
                      :class="
                        itemslist.payStatus == '0'
                          ? 'PendPayment'
                          : itemslist.payStatus == '1'
                          ? 'overgetmoney'
                          : 'toConfirmed'
                      "
                    >
                      {{
                        itemslist.payStatus == "0"
                          ? "待付款"
                          : itemslist.payStatus == "1"
                          ? "已付款"
                          : "待确认"
                      }}
                    </div>
                  </div>
                  <div class="iconbox">
                    <div><i class="el-icon-arrow-right"></i></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </template>
    </div>
  </div>
</template>
<script>
import headbox from "@/components/head.vue";
import * as JieSuanOrderListApi from "@/utils/api";
export default {
  data() {
    return {
      havedataboolean: false,
      startload: true,
      ishow: true,
      selllist: [],
      // 是否待确认
      isTobeconfirmed: false,
      // 待确认列表
      newproductlist: []
    };
  },
  mounted() {
    if (this.$route.query.sellMaterials) {
      this.isTobeconfirmed = true;
    }

    JieSuanOrderListApi.queryJieSuanOrderList({ orderType: 0 })
      .then(res => {
        // console.log('res',res);
        if (res.code == 0) {
          this.startload = false;
          this.selllist = res.data;
          // console.log(this.selllist);
          this.ishow = false;
          this.showyear();
          for (const b in this.selllist) {
            for (const i in this.selllist[b].orderList) {
              //  六改:   判断订单类型 ：0 卖出  1 压盘预付  2 压盘尾款
              if (this.selllist[b].orderList[i].orderType == 0) {
                this.havedataboolean = true;
              }
            }
          }
        }
      })
      .catch(err => {
        this.ishow = true;
      });
  },
  methods: {
    // 年份时间里是否包含待确认数据
    showyear() {
      const selllist_ = this.selllist;
      for (const i in selllist_) {
        this.newproductlist.push({
          year: selllist_[i].date,
          ishavadata: false
        });
        // console.log('newproductlist:',this.newproductlist);
        // debugger;
        for (const b in selllist_[i].orderList) {
          //  卖出订单
          if (selllist_[i].orderList[b].orderType == 0) {
            //  每单的时间？
            const getyear = selllist_[i].orderList[b].date.split(" ")[0];
            const yearmonth =
              getyear.split("-")[0] + "-" + getyear.split("-")[1];
              
              // console.log('year:'+ getyear);
              // console.log('month:', yearmonth);

            for (const item in this.newproductlist) {
              if(this.$route.query.sellMaterials){
                this.newproductlist[item].ishavadata = false;
              }else if (this.newproductlist[item].year == yearmonth) {
                this.newproductlist[item].ishavadata = true;
              }
              
              // console.log('newproductlist:'+ this.newproductlist[item]);
            }
          }
        }
      }
    },
    hrefdetails(orderId, paytype) {
      this.$router.push({
        name: "selldetails",
        query: { orderid: orderId, payType: paytype }
      });
    }
  },
  components: {
    headbox
  }
};
</script>

<style lang="scss" scoped="true">
#loadingbox {
  margin-top: 150px;
}
.van-empty {
  margin-top: 150px;
}
.onlyicon {
  align-items: center;
  .iconbox {
    margin-left: 20px;
  }
}
.PendPayment {
  color: #39ba1f;
}
.overgetmoney {
  color: #999999;
}
.sellbox {
  color: #fff;
  background: #ff5e1f;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  line-height: 70px;
  font-size: 32px;
  position: relative;
  top: 7px;
  text-align: center;
}
.mart20 {
  margin-top: 15px;
}
.f32 {
  font-size: 32px;
}
.f24 {
  font-size: 24px;
}
.toConfirmed {
  color: #ff5e1f;
}
.product_msg {
  margin-left: 20px;
}
.f24_gray {
  margin-top: 15px;
  font-size: 24px;
  color: #999999;
}
.f30_black {
  font-size: 30px;
  color: #292929;
}
.detailsbox {
  margin: 0 30px;
  padding: 30px 0;
  border-bottom: 1px solid #efefef;
}
.lastnoborder {
  border-bottom: 0;
}
.time {
  background: #f7f7f7;
  color: #b8b8b8;
  font-size: 28px;
  padding: 15px 30px;
}
</style>
